import { render } from "./contacts.vue?vue&type=template&id=c74a83e4"
import script from "./contacts.vue?vue&type=script&lang=js"
export * from "./contacts.vue?vue&type=script&lang=js"

import "./contacts.vue?vue&type=style&index=0&id=c74a83e4&lang=less"

import exportComponent from "/Users/alex/Documents/Google Ads/Panorama Residence/Panorama web/panorama-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__